import React, { Context, PropsWithChildren } from "react";

import { AffinityFormContext } from "./controls/affinityFormContext";
import { WithInnerFormContext } from "./controls/innerFormContext";
import { useAffinityForm, useAffinityFormOptions, useAffinityFormReturn } from "./controls/useAffinityFormControls";
import { ValueRecord } from "./types";

type AffinityFormProps<DATA extends ValueRecord = ValueRecord> = useAffinityFormOptions<DATA>;

export const AffinityForm = <DATA extends ValueRecord>({
  initialData,
  validate,
  validationSchema,
  asyncValidation,
  confirmHandler,
  children,
  context,
}: PropsWithChildren<AffinityFormProps<DATA>> & {
  context?: Context<Maybe<useAffinityFormReturn<DATA>>>;
}): React.ReactElement => {
  const form = useAffinityForm<DATA>({ initialData, validate, validationSchema, confirmHandler, asyncValidation });
  const FormContext = context ?? (AffinityFormContext as unknown as Context<Maybe<useAffinityFormReturn<DATA>>>);
  return (
    <FormContext.Provider value={form}>
      <WithInnerFormContext formContext={FormContext}>{children}</WithInnerFormContext>
    </FormContext.Provider>
  );
};
